import React, { useState, useEffect, useMemo } from 'react';

import { Card, CardBody } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import * as acquisitionOrdersActions from '../../store/acquisitionOrders/actions';
import { negativeMonetizationItemForAcquisitionOrders } from '../../selectors/monetizationItem';
import DataTableNext from '../Common/DataTable/DataTableNext';
import { getLabel } from '../Common/DataTable/tableHelpers';
import { capitalize } from '../../helpers/sharedFunction';

import roles from '../../config/roles';
import { useTranslation } from 'react-i18next';

const NegativeMonetizationItemInsights = ({ userId, role }) => {
  const negativeMonetizationItems = useSelector(
    negativeMonetizationItemForAcquisitionOrders(userId),
  );
  const acquisitionOrders = useSelector(
    (state) => state.AcquisitionOrder.acquisitionOrders,
  );

  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(30);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(acquisitionOrdersActions.syncAcquisitionOrders());
  }, []);

  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        title: 'Acquisition Order',
        name: 'acquisitionOrderId',
        getCellValue: (row) =>
          getLabel(row.acquisitionOrderId, acquisitionOrders),
      },
      {
        title: 'Sector',
        name: 'sector',
      },
      {
        title: 'Negative Outcome',
        name: 'negativeOutcome',
        width: 150,
        getCellValue: (row) =>
          row.negativeOutcome ? t(capitalize(row.negativeOutcome)) : '',
      },
      {
        title: 'Closures',
        name: 'count',
        width: 110,
        summary: 'sum',
      },
    ],
    [acquisitionOrders, t],
  );

  const costColumn = useMemo(
    () =>
      [roles.ADMIN, roles.SUPER_ADMIN].includes(role)
        ? [
            {
              title: 'Qualify costs',
              name: 'costs',
              width: 180,
              formatterComponent: ({ value }) => `€ ${value.toFixed(2)}`,
              summary: 'sum',
            },
          ]
        : [],
    [role],
  );

  const allColumns = useMemo(
    () => [...columns, ...costColumn],
    [columns, costColumn],
  );

  return (
    <Card>
      <CardBody>
        <DataTableNext
          loading={false}
          rows={negativeMonetizationItems}
          columns={allColumns}
          filters={filters}
          onFiltersChange={setFilters}
          sorting={sorting}
          onSortingChange={setSorting}
          currentPage={currentPage}
          onCurrentPageChange={setCurrentPage}
          pageSize={pageSize}
          onPageSizeChange={setPageSize}
        />
      </CardBody>
    </Card>
  );
};

export default NegativeMonetizationItemInsights;
